import React from "react";
import { Snackbar, Alert } from "@mui/material";

const CustomAlert = ({ open, message, severity, onClose }) => {
	return (
		<Snackbar
			open={open}
			autoHideDuration={5000}
			onClose={onClose}
			anchorOrigin={{ vertical: "top", horizontal: "center" }}
			sx={{
				position: "fixed",
				zIndex: 9999,
				top: "20px",
			}}
		>
			<Alert
				onClose={onClose}
				severity={severity}
				variant="filled"
				sx={{
					width: "100%",
					minWidth: "300px",
					bgcolor: severity === "success" ? "#c77c2f" : undefined,
				}}
			>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default CustomAlert;
